import { APIClientProvider } from "@heidelbergmaterials/fcl-apiclient"
import { useAuthentication } from "@heidelbergmaterials/fcl-authclient"
import { ReactNode } from "react"

interface FcpApiClientProviderProps {
	children: ReactNode
}

/**
 * FCP (Framework Component Library) API Client Provider
 * Wraps the application with an authenticated Axios client using fcl-apiclient
 *
 * This provider:
 * - Creates an APIClient instance configured with the Carbon Bank API base URL
 * - Integrates with FCP AuthenticationFlow for automatic token injection
 * - Handles 401 responses with automatic token refresh and retry
 * - Provides the client to child components via useAPIClient hook
 *
 * Must be nested inside FcpAuthProvider to access authentication state
 */
export const FcpApiClientProvider: React.FC<FcpApiClientProviderProps> = ({
	children,
}) => {
	const { authFlow } = useAuthentication()
	const baseURL = import.meta.env.VITE_SUSTAINABILITY_CARBONBANK_API

	return (
		<APIClientProvider
			baseURL={baseURL}
			authFlow={authFlow}
			defaultHeaders={{
				"Content-Type": "application/json",
			}}
		>
			{children}
		</APIClientProvider>
	)
}
